
import React, { useState, useEffect } from 'react';
import { useInView } from '../utils/animations';
import CategoryToggle from './portfolio/CategoryToggle';
import PortfolioList from './portfolio/PortfolioList';
import { photoItems as allPhotoItems, filmItems } from './portfolio/portfolioData';

const homePhotoItems = allPhotoItems.filter(item => item.title !== "ANETA + ADAM");

const Portfolio = () => {
  const [sectionRef, sectionInView] = useInView({ threshold: 0.1 });
  const [activeCategory, setActiveCategory] = useState<'photos' | 'films'>('photos');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getPortfolioItems = () => {
    switch (activeCategory) {
      case 'photos':
        return homePhotoItems;
      case 'films':
        return filmItems;
      default:
        return homePhotoItems;
    }
  };

  return (
    <section id="portfolio" className="py-16 md:py-20 bg-elegant-50">
      <div 
        ref={sectionRef as any} 
        className={`container-custom px-4 text-center ${
          sectionInView 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-10'
        } transition-all duration-700 ease-out`}
      >
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h2 className="text-2xl md:text-3xl font-serif text-elegant-900 mb-3 tracking-tight">
            Czułe Portfolio
          </h2>
          <p className="text-elegant-600 font-light text-sm md:text-base font-sans uppercase">
            POZNAJ HISTORIE NASZYCH PAR I ZAINSPIRUJ SIĘ PRAWDZIWYMI CHWILAMI, KTÓRE UWIECHNILIŚMY W NASZYCH FILMACH I FOTOGRAFIACH.
          </p>
        </div>

        <CategoryToggle activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
        <PortfolioList items={getPortfolioItems()} isMobile={isMobile} activeCategory={activeCategory} />
      </div>
    </section>
  );
};

export default Portfolio;
